import React, { useState } from 'react';
import { useTheme } from 'react-jss';
import { slide as Menu } from 'react-burger-menu';
import '../../../scss/common/Layout/Sidebare/MenuComponent/MenuComponent.scss'
import mobileViewLogo from '../../../asset/svg/mobileViewLogo.svg';
import coinsWon from '../../../asset/svg/coinsWon.svg';

const getMenuStyles = ({ theme }) => ({

    bmBurgerButton: {
        position: 'absolute',
        width: 26,
        height: 20,
        left: 30,
        top: 40,
        zIndex: 19
    },
    bmBurgerBars: {
        background: theme.color.veryDarkGrayishBlue
    },
    bmBurgerBarsHover: {
        background: theme.color.darkRed
    },
    bmCrossButton: {
        display: 'none'
    },
    bmCross: {
        background: theme.color.grayishBlue3
    },
    bmMenuWrap: {
        position: 'fixed',
        height: '100%',
        width: 270,
        zIndex: 30
    },
    bmMenu: {
        background: '#021239'
    },
    bmItem: {
        outline: 'none',
        '&:focus': {
            outline: 'none'
        }
    },
    bmMorphShape: {
        fill: theme.color.veryDarkGrayishBlue
    },
    bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 20
    }
});

function MenuComponent({ children, isMobile }) {
    const theme = useTheme();
    const menuStyles = getMenuStyles({ theme });
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <Menu
                isOpen={!isMobile || isOpen}
                noOverlay={!isMobile}
                disableCloseOnEsc
                styles={menuStyles}
                onStateChange={(state) => setIsOpen(state.isOpen)}
            >
                {children}
            </Menu>
            <div className='menuComponent-container'>
                <div className='menuComponent-container_header'>
                    <div className='menuComponent-container_header_image-container'>
                        <div>
                            <img className='menuComponent-container_header_image-container_logo' src={mobileViewLogo} alt="" />
                        </div>
                        <div style={{ display: 'flex', color: 'white', alignItems: 'center' }}> <img className='menuComponent-container_header_image-container_coinLogo' src={coinsWon} alt="" />&nbsp;&nbsp;7000</div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default MenuComponent;
